<script>
import EatingStudyCard from "@/views/EatingStudyPage/EatingStudyCard.vue"

export default {
  name: "EatingSurveyHome",
  components: { EatingStudyCard },
  data() {
    return {
      limit: 6,
      page: null,
      eatingStudies: null,
      EatingStudyCount: null,
      canteenName: null,
      searchTerm: null,
      options: {
        sortBy: [],
        sortDesc: [],
        page: 1,
      },
    }
  },
  computed: {
    loading() {
      return this.EatingStudyCount === null
    },
    offset() {
      return (this.page - 1) * this.limit
    },
  },
  methods: {
    search() {
      if (this.searchTerm && this.options.page !== 1) {
        this.options.page = 1
      } else {
        this.$router.push({ query: this.getUrlQueryParams() }).catch(() => {})
      }
    },
    getUrlQueryParams() {
      const urlQueryParams = { page: this.options.page }
      if (this.searchTerm) {
        urlQueryParams.recherche = this.searchTerm
      }
      return urlQueryParams
    },
    fetchCurrentPage() {
      const urlQueryParams = { page: this.options.page }
      if (this.searchTerm) {
        urlQueryParams.recherche = this.searchTerm
      }
      this.$store
        .dispatch("fetchEatingStudy", { offset: this.offset, search: this.searchTerm })
        .then((response) => {
          this.eatingStudies = response
          this.EatingStudyCount = response.length
          console.log("found " + JSON.stringify(response))
        })
        .catch(() => {
          this.$store.dispatch("notifyServerError")
        })
    },
    clearSearch() {
      this.searchTerm = ""
      this.search()
    },
    updateRoute() {
      const query = { page: this.page }
      if (this.$route.query.page) {
        this.$router.push({ query }).catch(() => {})
      } else {
        this.$router.replace({ query }).catch(() => {})
      }
    },
    populateParameters() {
      this.page = this.$route.query.page ? parseInt(this.$route.query.page, 10) : 1
    },
  },
  watch: {
    page() {
      this.updateRoute()
    },
    $route(newRoute, oldRoute) {
      this.eatingStudies = null
      if (newRoute.query.etiquette !== oldRoute.query.etiquette) {
        this.EatingStudyCount = null
      }
      this.populateParameters()
      this.fetchCurrentPage()
    },
  },
  mounted() {
    this.populateParameters()
    if (Object.keys(this.$route.query).length > 0) {
      this.fetchCurrentPage()
    }
  },
}
</script>

<template>
  <div class="eating-study-home">
    <!-- Titre principal -->
    <h1 class="text-center">Études Alimentaires</h1>

    <!-- Liste des études alimentaires -->
    <v-container>
      <v-row>
        <v-col v-for="study in eatingStudies" :key="study.id" cols="12" sm="6" md="4">
          <EatingStudyCard :study="study" />
        </v-col>
      </v-row>
    </v-container>

    <!-- Bouton pour ajouter une nouvelle étude -->
    <div class="text-center my-4">
      <router-link
        outlined
        :to="{ name: 'CreateEatingStudy' }"
        class="fr-btn fr-btn--secondary fr-btn--sm fr-mr-1w fr-mb-1w"
      >
        Créer une nouvelle étude
      </router-link>
    </div>
  </div>
</template>

<style scoped>
.eating-study-home {
  padding: 20px;
}

.eating-studies {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
}

h1 {
  font-size: 2rem;
  margin-bottom: 20px;
  color: #1e88e5;
}
.add-study-button {
  text-decoration: none;
}

.add-study-button > v-btn {
  font-size: 1rem;
  font-weight: bold;
}

.text-center {
  text-align: center;
}

.my-4 {
  margin-top: 16px;
  margin-bottom: 16px;
}
</style>
